export enum MessageContentType {
    TEXT = 'TEXT',
    IMAGE = "IMAGE",
    OFFER = "OFFER",
}